var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrophone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_3a)",
    d: "M10 2C8.3438 2 7 3.3438 7 5v5c0 1.6562 1.3438 3 3 3s3-1.3438 3-3V5c0-1.6562-1.3438-3-3-3M6 8.75A.748.748 0 0 0 5.25 8a.748.748 0 0 0-.75.75V10c0 2.7844 2.0687 5.0844 4.75 5.45v1.05h-1.5a.748.748 0 0 0-.75.75c0 .4156.3344.75.75.75h4.5c.4156 0 .75-.3344.75-.75a.748.748 0 0 0-.75-.75h-1.5v-1.05c2.6813-.3656 4.75-2.6656 4.75-5.45V8.75a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75V10c0 2.2094-1.7906 4-4 4s-4-1.7906-4-4z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_3a",
    x1: 5.2248,
    x2: 22.53,
    y1: 0.1879,
    y2: 8.9241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrophone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microphone.0e536f9fd5defd8fde46c42e722f1f63.svg";